/**
 * API по базовым справочникам АМЛ.
 * API по базовым справочникам АМЛ.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Данные записи справочника КГРКО.
 */
export interface QrefBarx { 
    /**
     * Регистрационный номер. Ключевое поле таблицы.
     */
    regn?: string;
    /**
     * Регистрационный номер. Ключевое поле таблицы.
     */
    regn1?: string;
}

